import {
  createSlice,
  type PayloadAction,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import type { BrandingSliceState } from './branding.type';
import { api } from '../../services/branding/operations.generated';
import { type ClinicBranding } from '../../services/graphQlTypes.generated';

const initialState: BrandingSliceState = {
  isPending: true,
  branding: undefined,
};

export const brandingSlice = createSlice({
  name: 'branding',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(initializeAsync.pending, (state) => {
      state.isPending = true;
    });

    builder.addCase(
      initializeAsync.fulfilled,
      (state, action: PayloadAction<ClinicBranding | null>) => {
        if (action.payload !== null) {
          state.branding = action.payload;
        }

        state.isPending = false;
      },
    );

    builder.addMatcher(
      api.endpoints.getClinicBranding.matchFulfilled,
      (state, { payload }) => {
        const result = payload.Branding.getClinicBranding as ClinicBranding;
        if (result) {
          state.branding = {
            ...result,
            primaryColor: result.primaryColor ?? undefined,
          };
        }
      },
    );
  },
});

export const initializeAsync = createAsyncThunk(
  'branding/initialize',
  async (
    institutionId: string | undefined,
    { dispatch },
  ): Promise<ClinicBranding | null> => {
    if (!institutionId) {
      return null;
    }

    const brandingResult = await dispatch(
      api.endpoints.getClinicBranding.initiate({
        clinicId: institutionId.toString(),
      }),
    ).unwrap();

    const result = brandingResult.Branding.getClinicBranding as ClinicBranding;
    return {
      ...result,
      primaryColor: result.primaryColor ?? undefined,
    };
  },
);
